import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import type { UserRead } from '../../../api/types';
import { useAuth } from '../../../app/providers/useAuth';
import { grantVoiceConsent } from '../api/voiceApi';

// PARA-132 (AC-7) — выдача согласия. Обновлённый профиль кладётся в
// AuthContext, чтобы статус согласия пережил переоткрытие формы без
// повторного логина. EC-21: при ошибке user не меняется.
export function useGrantVoiceConsent(): UseMutationResult<UserRead, Error, void> {
  const { applyUser } = useAuth();

  return useMutation({
    mutationFn: grantVoiceConsent,
    onSuccess: (user) => applyUser(user),
  });
}
